import { useNavigate } from 'react-router-dom';
import { learningPath } from '../data/agents';
import { Brain, ArrowLeft } from '../components/Icons';

export default function LearningPathPage() {
  const navigate = useNavigate();

  return (
    <div className="page-enter">
      <div className="detail-header">
        <button className="back-link" onClick={() => navigate('/')}>
          <ArrowLeft /> Back to home
        </button>
        <div className="icon-large"><Brain /></div>
        <h1>Learning <span style={{ color: 'var(--green)' }}>Path</span></h1>
        <div className="subtitle">From zero to production multi-agent system in 12-16 weeks</div>
      </div>

      <div style={{ marginTop: 40 }}>
        {learningPath.map((step, i) => (
          <div key={i} className={`path-step page-enter stagger-${i + 1}`}>
            <div className="path-step-number" style={{ borderColor: step.color, color: step.color }}>
              {step.phase}
            </div>
            <div className="path-step-content">
              <h3 style={{ color: step.color }}>{step.title}</h3>
              <div className="duration">{step.duration}</div>
              <ul>
                {step.items.map((item, j) => (
                  <li key={j}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      <div className="callout-box">
        <h3 style={{ color: 'var(--yellow)' }}>✦ How to Practice</h3>
        <p>
          Use <code className="highlight">Claude Code</code> as your
          implementation partner. Start every session with{' '}
          <code className="text">claude &quot;Read CLAUDE.md&quot;</code> to give
          it full project context. Build skills one at a time: write the prompt,
          implement the skill, write the test. Each skill is a self-contained
          learning exercise that teaches prompt engineering, structured output,
          and test-driven development with AI.
        </p>
      </div>
    </div>
  );
}
